import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';

import s from './Aside.scss';

import Dropdown from '../Dropdown';
import Link from '../Link';
import Icon from '../Icon/Icon';
import Search from '../Search/Search';

import { sidebar, sites } from '../../configPublic';
import {
  setRuntimeVariable,
  // alert as alertAction,
} from '../../actions/runtime';
import { RUNTIME_MOBILE_SIDEBAR_VISIBLE, RUNTIME_MODAL } from '../../constants';

const messages = defineMessages({
  settings: {
    id: 'aside.settings',
    defaultMessage: 'CMD CTRL',
  },
  home: {
    id: 'aside.home',
    defaultMessage: 'Home',
  },
});

class Aside extends Component {
  state = {
    isShowSearchResults: false,
  };

  handleToggleSearchResults = isShowSearchResults => {
    this.setState({ isShowSearchResults });
  };

  renderMenu(linksVar) {
    const { config } = this.props;
    const { routeParams, intl } = this.context;
    const { siteId } = routeParams;

    const links =
      typeof linksVar === 'function'
        ? linksVar((this.props.session.USER_DATA || {}).group, siteId, intl)
        : linksVar;

    const scope = this;
    const output = (links || []).map((link, index) => {
      const isDefaultActive = (config.to || []).find(itm => itm === link.index);

      return link.links ? (
        <li className="Aside__item" key={index}>
          <Dropdown
            dropClassName="Aside__dropdown --isDropped"
            mouseOutHandler={false}
            mouseOverHandler={false}
            defaultActive={!!isDefaultActive}
            style={{ width: '100%' }}
          >
            {scope.renderLink(link)}
            <ul className="Aside__nav --sec">{scope.renderMenu(link.links)}</ul>
          </Dropdown>
        </li>
      ) : (
        <li className="Aside__item" key={index}>
          {scope.renderLink(link)}
        </li>
      );
    });

    return output;
  }

  renderLink(link) {
    const { url, routeParams } = this.context;
    const { setMobileSidebarVisible, onClose } = this.props;
    const urlParams =
      Array.isArray(link.to) && link.to.length > 1
        ? Object.assign(routeParams, link.to[1])
        : routeParams;
    return Array.isArray(link.to) ? (
      <Link
        to={link.to ? url.getUrl(link.to[0], urlParams) : null}
        target={link.target}
        className={link.links ? `Aside__linkBullet` : `Aside__link`}
        activeClassName="--active"
        onClick={() => {
          onClose();
          setMobileSidebarVisible(false);
        }}
      >
        <span className="Aside__navIcon">
          {link.icon && <Icon icon={link.icon} />}
        </span>
        <span className="Aside__linkTitle">{link.title}</span>
      </Link>
    ) : (
      <a
        href={link.to}
        target={link.target}
        className={link.links ? `Aside__linkBullet` : `Aside__link`}
      >
        <span className="Aside__navIcon">
          {link.icon && <Icon icon={link.icon} />}
        </span>
        <span className="Aside__linkTitle">{link.title}</span>
      </a>
    );
  }

  render() {
    const {
      session,
      setMobileSidebarVisible,
      onClose,
      apps,
      isMobileSidebarVisible,
    } = this.props;
    const { url, routeParams } = this.context;
    const { isShowSearchResults } = this.state;
    const { siteId } = routeParams;
    const config = this.props.config ? this.props.config : sidebar.clubskp;
    const links = this.renderMenu(config.links);
    const title = (config.title || []).map((fragment, index) => (
      <span key={index}>{fragment.text}</span>
    ));

    // console.info({ apps });

    const isControl = config.to.find(itm => itm === 'control-index');

    // console.log("config: ", this.props.config);

    return (
      <div
        className={cx('Aside', {
          '--isShow': isMobileSidebarVisible,
          '--isControl': isControl,
        })}
      >
        <div className="Aside__inside">
          <div className="Aside__header">
            <Link to={url.getUrl('home', routeParams)}>
              <img className="Aside__logo" src={config.logoSrc} alt="" />
              {/* <div className="Aside__companyName">Henkel Beauty Care</div> */}
            </Link>

            <Link
              className="Aside__title"
              to={url.getUrl(...config.to, routeParams)}
            >
              {title}
            </Link>
          </div>

          <div
            className="Aside__searchContainer"
            style={{ flexGrow: isShowSearchResults ? 1 : 0 }}
          >
            <Search
              onShowSearchResults={val => this.handleToggleSearchResults(val)}
              siteId={siteId}
            />
          </div>

          {!isShowSearchResults && (
            <div className="Aside__body">
              <div className="Aside__menu">
                <ul className="Aside__nav">{links}</ul>
              </div>

              {!isControl && apps.find(app => app === 'cmdctrl') != null && (
                <ul className="Aside__nav --footer">
                  <li className="Aside__item">
                    <Link
                      className="Aside__link"
                      to={url.getUrl('control', routeParams)}
                      onClick={() => {
                        onClose();
                        setMobileSidebarVisible(false);
                      }}
                    >
                      <span className="Aside__navIcon">
                        <Icon icon="configurator" />
                      </span>
                      <span className="Aside__linkTitle">
                        <FormattedMessage {...messages.settings} />
                      </span>
                    </Link>
                  </li>
                </ul>
              )}

              {isControl && (
                <ul className="Aside__nav --footer">
                  <li className="Aside__item">
                    <Link
                      className="Aside__link"
                      to={url.getUrl('mytracker', routeParams)}
                      onClick={() => {
                        onClose();
                        setMobileSidebarVisible(false);
                      }}
                    >
                      <span className="Aside__navIcon">
                        <Icon icon="home" />
                      </span>
                      <span className="Aside__linkTitle">
                        <FormattedMessage {...messages.home} />
                      </span>
                    </Link>
                  </li>
                </ul>
              )}

              <ul className="Aside__footer">
                {/* <li>
                  <a
                    href="https://myskp-usa.zendesk.com/hc/en-us/requests/new"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Need Help?
                  </a>
                </li> */}
                <li>
                  <a
                    href="https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Terms of Use
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.henkel-northamerica.com/privacy-statement-na?view=content-blank"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <button onClick={() => window.Optanon.ToggleInfoDisplay()}>
                    Cookies
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>

        <button
          type="button"
          className="Aside__close"
          onClick={() => {
            onClose();
            setMobileSidebarVisible(false);
          }}
        >
          <Icon icon="xmark" />
        </button>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setMobileSidebarVisible: visible => {
    dispatch(
      setRuntimeVariable({
        name: RUNTIME_MOBILE_SIDEBAR_VISIBLE,
        value: visible,
      }),
    );
    if (visible) {
      dispatch(
        setRuntimeVariable({
          name: RUNTIME_MODAL,
          value: {
            type: 'aside',
            payload: {
              onClose: () => {
                dispatch(
                  setRuntimeVariable({
                    name: RUNTIME_MOBILE_SIDEBAR_VISIBLE,
                    value: false,
                  }),
                );
              },
            },
          },
        }),
      );
    }
  },
});

Aside.propTypes = {
  session: PropTypes.object,
  config: PropTypes.object,
  setMobileSidebarVisible: PropTypes.func.isRequired,
  pointsBalance: PropTypes.number.isRequired,
  onClose: PropTypes.func,
  apps: PropTypes.arrayOf(PropTypes.string),
  isMobileSidebarVisible: PropTypes.bool,
};

Aside.contextTypes = {
  routeParams: PropTypes.object.isRequired,
  url: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
};

Aside.defaultProps = {
  apps: [],
};

export default connect(
  state => ({
    session: state.session,
    pointsBalance: state.session.POINTS_BALANCE || 0,
    apps: ((state.session.USER_DATA || {}).group || {}).modules,
  }),
  mapDispatchToProps,
)(withStyles(s)(Aside));



// WEBPACK FOOTER //
// ./src/components/Aside/Aside.js